/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { assumptionEntryDtoSchema } from "./assumptionEntryDtoSchema.ts";
import { startupTierRowDtoSchema } from "./startupTierRowDtoSchema.ts";
import { z } from "zod/v4";

export const marketSizeStartupsDtoSchema = z.object({
  get tiers() {
    return z.array(startupTierRowDtoSchema).optional();
  },
  get somAssumptions() {
    return z.array(assumptionEntryDtoSchema).optional();
  },
});
